import React, { useState, useEffect, BaseSyntheticEvent, useRef, useCallback } from 'react'
import ReactDOM from 'react-dom'
import api from './api'
import onClickOutside from 'react-onclickoutside'
import _ from 'lodash'
import ReactSelect from 'react-select'
import TimeRange from 'live/components/ui/time-range'
import CheckBoxSelect, { TypeCheckBoxSelectOption, TypeFilter } from './componnents/checkboxSelect'
import DateService from 'live/services/date'
import {
    Content,
    ListErrorTests,
    MultSelect,
    OptionContainer,
    TimeRangeContainer,
    ErrorTestsContainer,
    ButtonContainer
} from './styles'
import { colorMap } from 'plugin-pressuretests/shared/components/PressureTestAnnotation'
import {
    SISPInstances,
    ISent,
    TestOption,
    SISPWell,
    SISPWellOption,
    TypeCallback,
    ApiResponse,
    ISISPTestType
} from './types'

import TooltipInfo from 'plugin-liverig/shared/components/TooltipInfo'
import moment from 'moment'
import LiveSelect from 'live/components/forms/ui/select'
import FormGroup from 'live/components/forms/ui/form-group'
import ActionToggle from 'live/components/ui/action-toggle'
import i18n from 'live/services/i18n'
import {
    getCorrelatedTestsBySource,
    getCorrelatedTestsComponnentBySource,
    getTestNameBySource,
    sendTestToSispBySource,
    setParentStyleByClassName,
    sispTestPayloadBuilder,
    getTestSISPIdBySource,
    DataSendTestType
} from './utils/index'


require('canvg')

/* 

In December 2022, the "SISP" label was replaced with "SIP",
changing only the strings that would be shown to users,
But not modifying the names of variables and functions

*/
window.RGBColor = require('rgbcolor')
window.StackBlur = require('stackblur')
interface Props {
    event: TestAnnotation
    getCharts: () => {
        curveChart: HTMLDivElement | null
        smoothCurveOnly: HTMLDivElement | null
        dropRateChart: HTMLDivElement | null
        originalChart: HTMLDivElement | null
    }
    results: { angularCoefficient: number; linearCoefficient: number }
    getAllChartTitles: () => {
        curveChartTitle: HTMLDivElement | null
        dropRateChartTitle: HTMLDivElement | null
        originalChartTitle: HTMLDivElement | null
        smoothCurveOnlyTitle: HTMLDivElement | null
    }
    getTestInfo: () => HTMLDivElement | null
}
const PressureTestsAnnotationAction: React.FC<Props> & { handleClickOutside?(): void } = (props: Props) => {
    const { event, getCharts, results, getTestInfo, getAllChartTitles } = props

    const SispComponentRef = useRef<HTMLDivElement | null>(null)
    const listCorrelatedTestsRef = useRef<HTMLDivElement>(null)

    const [showWellSelector, setShowWellSelector] = useState(false)
    const [instances, setInstances] = useState<SISPInstances | null>(null)
    const [sending, setSending] = useState(false)
    const [wellName, setWellName] = useState('')
    const [SISPTypes, setSISPTypes] = useState<ISISPTestType[]>([])
    const [testSISPId, setTestSISPId] = useState(getTestSISPIdBySource(event.__src))
    const [showGroupId, setShowGroupId] = useState(false)
    const [customGroupId, setCustomGroupId] = useState(Boolean(event.extra.extra?.testGroup))
    const [groupIdValue, setGroupIdValue] = useState(event.extra.extra?.testGroup)
    const [testId, setTestId] = useState('')
    const [latestRequestId, setLatestRequestId] = useState<number>()
    const [instanceName, setInstanceName] = useState('')
    const [sent, setSent] = useState<ISent | null>(null)
    const [end, setEnd] = useState<number>(new Date().getTime())
    const [loadingCorreletedTests, setLoadingCorreletedTests] = useState(false)
    const [error, setError] = useState<boolean | string>(false)
    const [correlatedTests, setCorrelatedTests] = useState<TestOption[]>([])
    const [checkedCorrelatedTests, setCheckedCorrelatedTests] = useState<TestOption[]>([])
    const [correlatedTestErrors, setCorrelatedTestErrors] = useState<TestOption[]>([])
    const [correlatedTestWarnings, setCorrelatedTestWarnings] = useState<TestOption[]>([])
    const [sendedTests, setSendedTests] = useState(0)
    const [selectedWellData, setSelectedWellData] = useState<SISPWell | null>(null)
    const [correlatedTestFilters, setCorrelatedTestFilters] = useState<TypeFilter<TestAnnotation>>({})
    const [showCorrelatedTestsList, setShowCorrelatedTestsList] = useState(true)

    useEffect(() => {
        api.list(
            (result: SISPInstances) => {
                setInstances(result)
            },
            (e: PromiseRejectedResult) => {
                setError('Status code: ' + e.status)
            }
        )
        !event.extra.extra?.testGroup && setGroupIdValue(setGroupIdDefaultValue(null))
    }, [])

    useEffect(() => {
        setCheckedCorrelatedTests(correlatedTests.filter(t => t.checked))
    }, [correlatedTests])

    const detailTestModalRef = useRef<HTMLDivElement | null>(null)
    useEffect(() => {
        setParentStyleByClassName(
            SispComponentRef?.current,
            'timeline__tooltip__context-container',
            'max-height',
            '600px'
        )

        setParentStyleByClassName(
            SispComponentRef?.current,
            'pressure_tests_annotation_container live-annotation live-annotation--expanded',
            'padding-top',
            '0px'
        )

        return () => {
            setParentStyleByClassName(
                SispComponentRef?.current,
                'timeline__tooltip__context-container',
                'max-height',
                null
            )

            setParentStyleByClassName(
                SispComponentRef?.current,
                'pressure_tests_annotation_container live-annotation live-annotation--expanded',
                'padding-top',
                null
            )
        }
    }, [instances])

    useEffect(() => {
        const groupType = instances?.[instanceName]?.filter(_instance => _instance.value === testSISPId)?.[0]?.group
        setShowGroupId(_.toString(groupType) === 'true')
    }, [instanceName, instances, testSISPId])

    const handleValueRenderer = (option: TypeCheckBoxSelectOption<TestAnnotation>): React.ReactNode => {
        return (
            <OptionContainer title={option.label}>
                <div>
                    <div>
                        <label>{option?.label}</label>
                        <span>
                            {i18n('by')} <b>{option.data.author}</b> ,{' '}
                            {DateService.fromNowCalendar(option.data.createdAt)}
                        </span>
                    </div>
                    <div>
                        <i
                            onClick={e =>
                                handleClickDetailTest(e, {
                                    ...option,
                                    data: { ...option.data, dashboard: props.event.dashboard, __src: event.__src }
                                })
                            }
                            className="far fa-eye"
                        />
                    </div>
                </div>

                <TimeRangeContainer>
                    <TimeRange
                        begin={option.data.begin}
                        end={option.data.end}
                        color={option.data.__color || colorMap[option.data.extra.result]}
                    />
                </TimeRangeContainer>
                <div></div>
            </OptionContainer>
        )
    }

    PressureTestsAnnotationAction.handleClickOutside = (): void => {
        setShowWellSelector(false)
    }

    const handleChangeGroupId = (e: BaseSyntheticEvent): void => {
        setCustomGroupId(true)
        setGroupIdValue(e.target.value)
    }

    const handleChangeWellSelection = (wellDataOption: SISPWellOption): void => {
        setSelectedWellData(wellDataOption.data)

        if (!customGroupId) {
            setGroupIdValue(setGroupIdDefaultValue(wellDataOption.data?.nomePoco))
        }
    }

    const handleToggleShowGroupId = (): void => {
        const groupType = instances?.[instanceName]?.filter(_instance => _instance.value === testSISPId)?.[0]?.group
        _.toString(groupType) === 'true' && setShowGroupId(!showGroupId)
    }

    const handleTestSISPId = (testSISPId: string): void => setTestSISPId(testSISPId)

    const setGroupIdDefaultValue = (wellName: string | undefined): string => {
        const createAt = event.createAt
        const year = moment(createAt).year()
        const weeks = moment(createAt).weeks()
        const well = wellName || selectedWellData?.nomePoco
        const author = event.author

        return `${year}_${weeks}${well ? '_' + well : ''}_${author}`
    }

    const getSelectWells = (input: unknown, callback: TypeCallback): void => {
        api.listWells(
            instanceName,
            event.timestamp,
            wellName,
            ({ data }: ApiResponse<{ data: SISPWell[]; error: string | boolean }>) => {
                callback(null, {
                    options: data.data ? wellsToOptions(data.data) : [],
                    complete: false
                })
                if (data.error) {
                    setError(data.error)
                }
            },
            (e: PromiseRejectedResult) => {
                setError('Status code: ' + e.status)
            }
        )
    }

    const loadCorrelatedTests = (): void => {
        const count = 10
        const filterByName = correlatedTestFilters.name?.checked ? getTestNameBySource(event.__src, event) : null
        const filterByAuthor = !correlatedTestFilters.author?.checked
        const callback = (data: TestAnnotation[]) => {
            const orderedData = data
                .sort((a, b) => (b.begin || b.start) - (a.begin || a.start))
                .filter(f => f.uid !== event.uid)
            setCorrelatedTests([...correlatedTests, ...testsToOptions(orderedData, event.__src)])
            setEnd(orderedData[orderedData.length - 1]?.begin || orderedData[orderedData.length - 1]?.start - 1)
            setLoadingCorreletedTests(false)
        }

        setLoadingCorreletedTests(true)
        getCorrelatedTestsBySource(
            event,
            count,
            end,
            filterByName,
            filterByAuthor,
            ({ data }) => callback(data),
            () => {
                setShowCorrelatedTestsList(false)
            }
        )
    }

    const sendTestToSISP = async (test: TestOption, next: number | null): Promise<void> => {
        setSendedTests(next + 1)
        const { wellId = '', wellboreId = '', eventId = '' } = selectedWellData

        const callNextTest = (nextTest: number, length: number, data?: DataSendTestType): void => {
            if (data?.result === 'warning') {
                setCorrelatedTestWarnings(correlatedTestWarnings => [...correlatedTestWarnings, test])
            }
            if (nextTest < length && nextTest < 1000) {
                sendTestToSISP(checkedCorrelatedTests[nextTest], nextTest + 1)
            } else {
                setSent(data || { result: 'success' })
                setSending(false)
            }
        }
        const callbackExportError = (e: Record<string, any>, msg: string | null = null): void => {
            if (next === 0) {
                // console.log(e)
                // console.log(msg)
                setSent({ result: 'error' })
                setSending(false)
            } else {
                next > 0 && setCorrelatedTestErrors(correlatedTestErrors => [...correlatedTestErrors, test])
                // console.log(`Error: Test ${next} ${test.data.uid} => ${e.status || e}`)
                // msg && console.log(msg)
                callNextTest(next, checkedCorrelatedTests.length)
            }
        }

        try {
            const payload = await sispTestPayloadBuilder(
                event.__src,
                test,
                listCorrelatedTestsRef,
                {
                    testId,
                    wellId,
                    wellboreId,
                    testSISPId,
                    eventId,
                    testGroup: showGroupId ? groupIdValue : ''
                },
                callbackExportError
            )
            sendTestToSispBySource(
                event.__src,
                test.data,
                instanceName,
                payload,
                showGroupId ? groupIdValue : null,
                data => callNextTest(next, checkedCorrelatedTests.length, data),
                callbackExportError
            )
        } catch (e) {
            callbackExportError(e, 'Sending all files and additional info')
        }
    }

    const sendToSISP = (): void => {
        setSending(true)
        sendTestToSISP(
            {
                ...testsToOptions([event], event.__src)[0],
                getAllChartTitles,
                getCharts,
                testInfo: getTestInfo ? getTestInfo() : () => ({})
            },
            0
        )
    }

    const loadWells = (requestId: number, instanceName: string, wellName: string | null = null): void => {
        const timestamp = event.begin

        setInstanceName(instanceName)
        setLatestRequestId(requestId)
        setShowWellSelector(true)

        setTestId(event.uid)

        setSelectedWellData({} as SISPWell)
        setSent(null)
        setError(false)

        api.listWells(
            instanceName,
            timestamp,
            wellName,
            ({ data }: ApiResponse<{ error: boolean; data: SISPWellOption[] }>) => {
                if (requestId !== latestRequestId) return

                if (data.error) {
                    setError(data.error)
                }
            },
            (e: PromiseRejectedResult) => {
                if (requestId !== latestRequestId) return

                setError('Status code: ' + e.status)
            }
        )
    }

    return (
        <Content
            ref={SispComponentRef}
            className="integration-sisp-pressure-test"
            style={{ height: 'auto' }}
            showGroupId={showGroupId && showCorrelatedTestsList}
        >
            {instances ? (
                <div className="sisp-instances">
                    {Object.keys(instances).map(instanceName => (
                        <div
                            data-testid={`send-to-sisp-div-${instanceName}`}
                            className="send-to-sisp"
                            key={instanceName}
                            onClick={() => {
                                setInstanceName(instanceName)
                                setWellName('')
                                setSISPTypes([...instances[instanceName]])

                                loadWells(1, instanceName)
                            }}
                        >
                            <i className="fa fa-share-square-o" aria-hidden="true" /> {i18n('Send to')}{' '}
                            {' ' + instanceName}
                        </div>
                    ))}
                </div>
            ) : (
                <i className="fa fa-spinner" aria-hidden="true" />
            )}

            {showWellSelector ? (
                <div className="well-selector">
                    {sent ? (
                        <SispResultContainer
                            sent={sent}
                            sendedTests={sendedTests}
                            ListErros={correlatedTestErrors}
                            ListTests={checkedCorrelatedTests}
                            ListWarnings={correlatedTestWarnings}
                            RendererTestError={handleValueRenderer}
                            TryAgainFn={sendToSISP}
                        />
                    ) : (
                        <div>
                            {!error ? (
                                <div>
                                    <MultSelect className="integration-sisp-pressure-test__header">
                                        <div className="integration-sisp-pressure-test__test_type_id_title">
                                            {i18n('Choose the SIP type test')}
                                        </div>
                                        <LiveSelect
                                            placeholder={i18n('Choose')}
                                            onChange={handleTestSISPId}
                                            value={testSISPId}
                                            clearable={false}
                                            options={SISPTypes}
                                        />
                                        <div>{i18n('Choose the well related with the test')}</div>
                                        <ReactSelect.Async
                                            placeholder={i18n('Select')}
                                            data-testeid="Async-select"
                                            onChange={handleChangeWellSelection}
                                            value={wellToValue(selectedWellData)}
                                            loadOptions={getSelectWells}
                                            clearable={false}
                                        />

                                        <div className="grouptest-toggle sisp-semi-bold-title">
                                            <ActionToggle
                                                onChange={handleToggleShowGroupId}
                                                active={showGroupId && showCorrelatedTestsList}
                                                disabled={
                                                    !showCorrelatedTestsList ||
                                                    !(
                                                        _.toString(
                                                            instances?.[instanceName]?.filter(
                                                                _instance => _instance.value === testSISPId
                                                            )?.[0]?.group
                                                        ) === 'true'
                                                    )
                                                }
                                            />
                                            <span>
                                                {i18n(showGroupId ? 'Group indentifier' : 'Join other test to send')}
                                            </span>
                                            <TooltipInfo icon="fa-question-circle-o" placement="top">
                                                {i18n(
                                                    'Need to register at least one test with "group" propertie as TRUE at the sip configuration json'
                                                )}
                                            </TooltipInfo>
                                        </div>
                                        <div
                                            data-testid="testgroup-div"
                                            style={{
                                                display: showGroupId && showCorrelatedTestsList ? 'flex' : 'none',
                                                flexDirection: 'column'
                                            }}
                                        >
                                            <FormGroup
                                                data-testid="testgroup-input"
                                                onChange={handleChangeGroupId}
                                                value={groupIdValue}
                                            />

                                            <span className="sisp-semi-bold-title">{i18n('Select tests to send')}</span>
                                            <CheckBoxSelect<TestAnnotation>
                                                onScrollBottom={l => !l && loadCorrelatedTests()}
                                                onNoScroll={l => !l && loadCorrelatedTests()}
                                                valueRenderer={handleValueRenderer}
                                                loading={loadingCorreletedTests}
                                                loadOptions={loadCorrelatedTests}
                                                options={correlatedTests}
                                                onChange={(opt, newOpts) => setCorrelatedTests(newOpts)}
                                                async
                                                onUpdateFilters={setCorrelatedTestFilters}
                                                filters={{
                                                    author: {
                                                        label: i18n('Only my tests'),
                                                        defaultValue: true
                                                    },
                                                    name: {
                                                        label: i18n('Same type tests')
                                                    }
                                                }}
                                                filterFn={(opt: TestOption, currentFilters) => {
                                                    if (
                                                        Object.keys(currentFilters).includes('author') &&
                                                        currentFilters.author.checked &&
                                                        opt.data.author !== event.author
                                                    ) {
                                                        return false
                                                    }

                                                    if (
                                                        Object.keys(currentFilters).includes('name') &&
                                                        currentFilters.name.checked &&
                                                        getTestNameBySource(event.__src, opt.data) !==
                                                            getTestNameBySource(event.__src, event)
                                                    ) {
                                                        return false
                                                    }

                                                    return true
                                                }}
                                            />
                                        </div>
                                        <div ref={listCorrelatedTestsRef} style={{ display: 'none' }}>
                                            {checkedCorrelatedTests.map((_test, id) => {
                                                const newOpt = [...checkedCorrelatedTests]
                                                const handleGetCharts = fn => {
                                                    newOpt[id].getCharts = fn
                                                    setCheckedCorrelatedTests(newOpt)
                                                }

                                                const handleGetAllChartTitles = fn => {
                                                    newOpt[id].getAllChartTitles = fn
                                                    setCheckedCorrelatedTests(newOpt)
                                                }

                                                return getCorrelatedTestsComponnentBySource(
                                                    event.__src,
                                                    _test.data.uid,
                                                    _test,
                                                    handleGetCharts,
                                                    handleGetAllChartTitles
                                                )
                                            })}
                                        </div>
                                    </MultSelect>
                                </div>
                            ) : (
                                <div className="sisp-result-container" style={{ height: '185px' }}>
                                    <div className="sisp-result">
                                        <i
                                            className="fa fa-times-circle"
                                            style={{ color: '#ef4548' }}
                                            aria-hidden="true"
                                        />
                                        <br />
                                        <br />
                                        <span>{i18n('Error loading well list')}</span>

                                        <br />
                                        {error ? i18n('Message') + ': ' + error : ''}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    {(!error || sending) && (
                        <ButtonContainer className="small-footer integration-sisp-pressure-test__footer">
                            {sent ? (
                                <button className="btn btn-default" onClick={() => setShowWellSelector(false)}>
                                    {i18n('Close')}
                                </button>
                            ) : (
                                <div className="btn-footer-container">
                                    <button
                                        className="btn btn-primary"
                                        disabled={!selectedWellData || sending}
                                        onClick={sendToSISP}
                                    >
                                        {sending ? (
                                            <span>
                                                <i className="fa fa-spinner fa-spin" /> {i18n('Processing')}
                                                {` ${sendedTests}/${checkedCorrelatedTests.length + 1}`}
                                            </span>
                                        ) : (
                                            i18n('Send')
                                        )}
                                    </button>

                                    <button
                                        className="btn btn-light"
                                        disabled={sending}
                                        onClick={() => setShowWellSelector(false)}
                                    >
                                        {i18n('Cancel')}
                                    </button>
                                </div>
                            )}
                        </ButtonContainer>
                    )}
                </div>
            ) : (
                ''
            )}
        </Content>
    )
}

const SispResultContainer = ({
    sent,
    sendedTests,
    ListErros,
    ListWarnings,
    ListTests,
    RendererTestError,
    TryAgainFn
}: {
    sent: {
        result: string
        message?: string
        error: string
    }
    sendedTests: number
    ListErros: TestOption[]
    ListWarnings: TestOption[]
    ListTests: TestOption[]
    RendererTestError: () => void
    TryAgainFn: () => void
}): React.ReactElement => {
    return (
        <div className="sisp-result-container">
            {sent.result && (sent.result === 'success' || sent.result === 'warning') ? (
                <div className="sisp-result" style={{ margin: '-15% 0 0 -50%' }}>
                    <i
                        className="fa fa-check-circle"
                        style={{ color: ListWarnings.length > 0 ? '#e0dd2c' : '#3cea7f' }}
                        aria-hidden="true"
                    />

                    <br />

                    {i18n('Tests successfully sent')}
                    <br />
                    {`${sendedTests - ListErros.length}/${ListTests.length + 1}`}
                    <br />
                    {ListWarnings?.length > 0 && (
                        <p style={{ marginTop: 8 }}>{`${ListWarnings.length} ${i18n('Tests sended with errror')}`}</p>
                    )}
                    <br />
                    {sent?.message}
                    <br />
                    <SispResultError
                        ListErros={ListErros}
                        ListWarnings={ListWarnings}
                        RendererTestError={RendererTestError}
                    />
                </div>
            ) : (
                <div className="sisp-result">
                    <i className="fa fa-times-circle" style={{ color: '#ef4548' }} aria-hidden="true" />
                    <br />
                    {i18n('There was a problem sending the data')}
                    <br />
                    <a href="javascript:void(0)" onClick={TryAgainFn}>
                        {i18n('Try again')}
                    </a>
                    <br />
                    {sent.error ? i18n('Message') + ': ' + sent.error : ''}
                    <br />
                    {sent.message ? i18n('Message') + ': ' + sent.message : ''}
                </div>
            )}
        </div>
    )
}

const SispResultError = ({ ListErros, ListWarnings, RendererTestError }) => {
    return (
        <>
            {ListErros?.length > 0 || ListWarnings?.length > 0 ? (
                <ErrorTestsContainer>
                    {ListWarnings?.length > 0 && (
                        <>
                            <ListErrorTests>
                                <label className="title">
                                    <i
                                        className="fa fa-exclamation-triangle"
                                        style={{ color: '#e0dd2c' }}
                                        aria-hidden="true"
                                    />
                                    {i18n(`Tests sended without information:`)}
                                </label>
                            </ListErrorTests>

                            <ListErrorTests>
                                {ListWarnings?.map((err, key) => (
                                    <div key={key} className="test-error-container">
                                        {RendererTestError(err)}
                                    </div>
                                ))}
                            </ListErrorTests>
                        </>
                    )}
                    {ListErros?.length > 0 && (
                        <>
                            <ListErrorTests>
                                <label className="title">
                                    <i
                                        className="fa fa-exclamation-triangle"
                                        style={{ color: colorMap.failed }}
                                        aria-hidden="true"
                                    />
                                    {i18n(`Tests not sended:`)}
                                </label>
                            </ListErrorTests>

                            <ListErrorTests>
                                {ListErros?.map((err, key) => (
                                    <div key={key} className="test-error-container">
                                        {RendererTestError(err)}
                                    </div>
                                ))}
                            </ListErrorTests>
                        </>
                    )}
                </ErrorTestsContainer>
            ) : (
                ''
            )}
        </>
    )
}

const wellToValue = (well: SISPWell): string | undefined => {
    if (well) {
        return JSON.stringify({
            wellId: well.wellId,
            wellboreId: well.wellboreId,
            eventId: well.eventId
        })
    }
}

const wellsToOptions = (wells: SISPWell[]): SISPWellOption[] =>
    wells?.map(w => ({
        label: `${w.nomePoco} / ${w.nomeIntervencao}`,
        value: wellToValue(w) || '',
        data: w
    }))

const testsToOptions = (wells: TestAnnotation[], __src?: string): TestOption[] =>
    wells?.map(w => ({
        label: `${getTestNameBySource(__src, w)} ${DateService.fromNowCalendar(w.createdAt)} ${i18n('by')} ${w.author}`,
        value: `${w.createdAt}:${w.begin}/${w.end}`,
        color: w.__color,
        checked: false,
        data: { ...w, begin: w.start || w.begin }
    }))

const getParentClassName = (element: HTMLElement, _className: string, limit = 10): HTMLElement => {
    let parent = element.parentElement
    for (let i = 0; i < limit; i++) {
        if (parent && parent.classList.value.includes(_className)) {
            return parent
        } else if (!parent) {
            break
        } else {
            parent = parent.parentElement
        }
    }
}

const DetailTestComponent = ({ test }: { test: TestOption }): React.ReactElement => {
    const detailRef = useRef<HTMLDivElement>(null)
    const handleClose = () => detailRef?.current?.remove()

    const handleEsc = useCallback((e: KeyboardEvent): void => {
        if (e.keyCode === 27) {
            handleClose()
            e.preventDefault()
        }
    }, [])

    useEffect(() => {
        window.addEventListener('keydown', handleEsc)

        return () => {
            window.removeEventListener('keydown', handleEsc)
        }
    }, [])

    return (
        <div ref={detailRef} id="test">
            <div onClick={handleClose} className="modal-backdrop in" style={{ zIndex: 1052 }} />
            <div
                style={{
                    top: '50%',
                    left: '50%',
                    zIndex: 1080,
                    position: 'absolute',
                    width: '600px',
                    transform: 'translate3d(-50%, -50%, 0)',
                    backgroundColor: 'white'
                }}
            >
                <div
                    style={{
                        padding: '20px',
                        overflowY: 'scroll',
                        maxHeight: '600px'
                    }}
                >
                    {getCorrelatedTestsComponnentBySource(test.data.__src, test.value, test)}
                </div>

                <ButtonContainer className="modal-footer">
                    <button className="btn btn-default" onClick={handleClose}>
                        {i18n('Close')}
                    </button>
                </ButtonContainer>
            </div>
        </div>
    )
}

const handleClickDetailTest = (e: React.MouseEvent<HTMLElement, MouseEvent>, _test: TestOption): void => {
    e.stopPropagation()
    const modalRoot = document.createElement('div')
    window.document.body.appendChild(modalRoot)

    ReactDOM.render(<DetailTestComponent test={_test} />, modalRoot)

    // ServiceLocator.getService('annotation-service').then(s => s.showAnnotation(_test))
}

const clickOutsideConfig = {
    handleClickOutside: () => PressureTestsAnnotationAction.handleClickOutside
}

export default (onClickOutside(
    PressureTestsAnnotationAction,
    clickOutsideConfig
) as unknown) as typeof PressureTestsAnnotationAction
